import { camelCase } from 'lodash';

const TOOLBAR_V3_FEATURE_FLAG_KEY = 'web-ui-live-session-toolbar-v-3';
const TOOLBAR_V3_FEATURE_FLAG_NAME = camelCase(TOOLBAR_V3_FEATURE_FLAG_KEY);
const TOOLBAR_V3_FEATURE_FLAG_VARIATIONS = Object.freeze({
  TOPBAR_ONLY: 'topbar-only',
  TOP_AND_TOOLBAR: 'top-and-toolbar',
  OFF: 'off',
});

const WEB_RTC_ANDROID_FEATURE_FLAG_KEY = 'web-rtc-live-testing-android';
const WEB_RTC_ANDROID_FEATURE_FLAG_NAME = camelCase(WEB_RTC_ANDROID_FEATURE_FLAG_KEY);
const WEB_RTC_IOS_FEATURE_FLAG_KEY = 'web-rtc-live-testing-iOS';
const WEB_RTC_IOS_FEATURE_FLAG_NAME = camelCase(WEB_RTC_IOS_FEATURE_FLAG_KEY);

const TOPBAR_HEIGHT_PX = '56px' as const;

const PERFORMANCE_MODE_STATES = Object.freeze({
  DISABLED: 'disabled',
  ENABLED: 'enabled',
} as const);

export default {
  PERFORMANCE_MODE_STATES,
  TOOLBAR_V3_FEATURE_FLAG_NAME,
  TOOLBAR_V3_FEATURE_FLAG_VARIATIONS,
  TOPBAR_HEIGHT_PX,
  WEB_RTC_ANDROID_FEATURE_FLAG_NAME,
  WEB_RTC_IOS_FEATURE_FLAG_NAME,
};
